/**
 * 全局混入
*/
export const mixin = {
  methods: {
  }
}
